import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { UserSession } from '../../domain/user-session';
import { Parte } from '../../domain/parte';
import { ParteService } from '../../service/parte.service';
import { Subscription } from 'rxjs';
import { DetalleCarrito } from '../../domain/detalle-carrito';
import { GenericResponse } from '../../domain/genericResponse';
import { GLOBAL } from '../../global';
import { Carrito } from '../../domain/carrito';
import { ShoppingCartService } from '../../service/shopping-cart.service';
import { WishlistService } from '../../service/wishlist.service';
import { AuthService } from '../../service/auth/auth.service';
import { ProductDialogComponent } from '../products-carousel/product-dialog/product-dialog.component';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss']
})
export class ControlsComponent implements OnInit, OnDestroy {

  @Input() product: DetalleCarrito;
  @Input() type: string;
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Output() onQuantityChange: EventEmitter<any> = new EventEmitter<any>();
  public count: number = 1;
  public align = 'center center';

  public vlrUnitario: number = 0;

  userSession: UserSession = this.authService.getUser();
  subscription: Subscription;
  

  constructor(
    public snackBar: MatSnackBar,
    private authService: AuthService,
    private parteService: ParteService,
    private shoppingCartService: ShoppingCartService,
    public dialog: MatDialog,
    private wishlistService : WishlistService
  ) { }

  ngOnInit() {
//    this.userSession = this.authService.getUser();
    this.layoutAlign();
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-21
   */
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public layoutAlign() {
    if (this.type == 'all') {
      this.align = 'space-between center';
    }
    else if (this.type == 'wish') {
      this.align = 'start center';
    }
    else {
      this.align = 'center center';
    }
  }

  /**
   * Aumenta la cantidad de un producto del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-21
   */
  public increment() {
    // // FEDAZA: Obtengo la cantidad del producto disponible    
    // this.subscription = this.parteService.getDataParteConImagenes(this.product.partId, null, null, null, null, null, null, 0, 1)
    //   .subscribe((data: GenericResponse) => {
    //     if (data.codigo === GLOBAL.HTTP_OK) {
    //       let availibilityCount: number = data.lista[0].stock - this.product.cantidad;

    //       if (availibilityCount > 0) {
    //         // FEDAZA: Persisto los cambios en el localstorage
    //         let newCart: Carrito = this.appService.getCarrito();
    //         let newQuantity: number = 0;
    //         let newValorTotal: number = 0;

    //         newCart.listSicaDetalleCarrito.forEach(i => {
    //           if (i.partId === this.product.partId) {
    //             i.cantidad++;
    //             i.disponible = availibilityCount;
    //           }

    //           newQuantity += i.cantidad;
    //           newValorTotal += i.valorTotal * i.cantidad;
    //         });

    //         newCart.totalItems = newQuantity;
    //         newCart.valorTotal = newValorTotal;
    //         this.appService.carrito = newCart;
    //         this.appService.setCarrito(newCart);

    //         if (this.authService.isAuthenticate()) {
    //           this.appService.updateCarrito(newCart).subscribe();
    //         }
    //       } else {
    //         this.snackBar.open('No se puede elegir más artículos de los disponibles. En stock ' + availibilityCount + ' artículos.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    //       }
    //     }
    //   });
  }

  /**
   * Disminuye la cantidad de un producto del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-22
   * @param count 
   */
  public decrement() {
    // // FEDAZA: Obtengo la cantidad del producto disponible    
    // this.subscription = this.parteService.getDataParteConImagenes(this.product.partId, null, null, null, null, null, null, 0, 1)
    //   .subscribe((data: GenericResponse) => {
    //     if (data.codigo === GLOBAL.HTTP_OK) {
    //       let availibilityCount: number = data.lista[0].stock + this.product.cantidad;

    //       if (this.product.cantidad > 1) {
    //         // FEDAZA: Persisto los cambios en el localstorage
    //         let newCart: Carrito = this.appService.getCarrito();
    //         let newQuantity: number = 0;
    //         let newValorTotal: number = 0;

    //         newCart.listSicaDetalleCarrito.forEach(i => {
    //           if (i.partId === this.product.partId) {
    //             i.cantidad--;
    //             i.disponible = availibilityCount;
    //           }

    //           newQuantity += i.cantidad;
    //           newValorTotal += i.valorTotal * i.cantidad;
    //         });

    //         newCart.totalItems = newQuantity;
    //         newCart.valorTotal = newValorTotal;
    //         this.appService.carrito = newCart;
    //         this.appService.setCarrito(newCart);

    //         if (this.authService.isAuthenticate()) {
    //           this.appService.updateCarrito(newCart).subscribe();
    //         }
    //       }
    //     }
    //   });
  }

  /**
   * Aumenta la cantidad de un producto del carrito.
   * 
   * @author Camilo Delgado
   * @version 2018-11-21
   */
  public incrementShopping(first: boolean) {
    //console.log(first);
    let parte : Parte = new Parte();
    parte.nombre = this.product.nombre;
    parte.partId = this.product.partId;
    parte.codigo = this.product.codigoParte;
    if (this.authService.isAuthenticate()) {
      this.shoppingCartService.addToCart(parte, true, first);
    }else{
      this.shoppingCartService.addToCart(parte, false, first);
    }

  }

  /**
   * Disminuye la cantidad de un producto del carrito.
   * 
   * @author Camilo Delgado
   * @version 2018-11-22
   * @param count 
   */
  public decrementShopping() {
    let parte : Parte = new Parte();
    parte.nombre = this.product.nombre;
    parte.partId = this.product.partId;
    parte.codigo = this.product.codigoParte;
    if (this.authService.isAuthenticate()) {
      this.shoppingCartService.removeToCart(parte, true);
    }else{
      this.shoppingCartService.removeToCart(parte, false);
    }
  }

  /**
   * Agrega productos a la lista de deseos.
   * Si el usuario se encuentra autenticado, persiste la información
   * en el sistema, sino, la información de la lista de deseos no se persistirá en el sistema.
   * @param product 
   */
  public addToWishList(product: Parte) {
    if (this.authService.isAuthenticate()) {
      this.wishlistService.addToWishlist(product, this.userSession.jti);
    }
  }

  /**
   * Agrega productos al carrito de compras.
   * Si el usuario se encuentra autenticado, persiste la información
   * en el sistema, sino, la información del carrito no se persistirá en el sistema.
   * 
   * @author Frank Edward Daza González
   * @version 2018-10-29
   * @param product 
   */
  public addToCartShopping(product: Parte) {
    if (this.authService.isAuthenticate()) {
      this.shoppingCartService.addToCart(product, true, true);
    } else {
      this.shoppingCartService.addToCart(product, false, true);
    }
  }

  // public openProductDialog(event) {
  //   this.onOpenProductDialog.emit(event);
  // }

  public hideProductDialog() {
    this.dialog.closeAll();
  }



  public changeQuantity(value) {
    this.onQuantityChange.emit(value);
  }

  public openProductDialog(product){   
    let dialogRef = this.dialog.open(ProductDialogComponent, {
        data: product,
        panelClass: 'product-dialog'
    });
  }

  public removeFromWishlist(event){
    //console.log("entro")
    if (this.authService.isAuthenticate()) {
      //console.log("entro")
      this.onQuantityChange.emit(event);
    }
  }

  public inCarrito() : number{
    if(this.product == null){
      return 0;
    }
    let existe : number = 0;
    let newCart: Carrito = this.shoppingCartService.getCarrito();
    newCart.listSicaDetalleCarrito.forEach(i => {
      if (i.partId === this.product.partId) {
        existe = i.cantidad;
        this.product.cantidad = i.cantidad;
        this.vlrUnitario = i.cantidad * Math.round(i.valorTotal + (i.valorTotal * i.valorIva / 100));
      }
    });
    return existe;
  }

  public goBack(){
    if(this.dialog.openDialogs.length > 0){
      this.dialog.closeAll();
    }else{
      window.history.back()
    }
   // console.log(window.history.back());
  }
}